module.exports = __webpack_public_path__ + "img/img_about2.65b85a6b.png";